import Cookies from 'js-cookie'

import cookiesStorage from '@/store/storage/cookiesStorage'

import type { UserDTO } from '@/services/api/user/types'
export type AuthState = {
  accessToken: string
  refreshToken: string
  user: UserDTO
}
export const AUTH_STORE_KEY = 'authSlice'
const emptyAuthState = (): AuthState => ({ accessToken: '', refreshToken: '', user: {} as UserDTO })

export const getAuthSliceFromCookieValue = (raw: string | null | undefined): AuthState => {
  try {
    if (!raw) return emptyAuthState()

    const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw
    return parsed as AuthState
  } catch {
    return emptyAuthState()
  }
}

export const getAuthSliceSync = (): AuthState => {
  return getAuthSliceFromCookieValue(Cookies.get(AUTH_STORE_KEY))
}

export const getAuthSlice = async (): Promise<AuthState> => {
  const data = await cookiesStorage.getItem(AUTH_STORE_KEY)
  return getAuthSliceFromCookieValue(data)
}

export const setAuthSlice = async (payload: Partial<AuthState>) => {
  const state = await getAuthSlice()
  await cookiesStorage.setItem(AUTH_STORE_KEY, JSON.stringify({ ...state, ...payload }))
}

export const clearAuthSlice = async () => {
  await cookiesStorage.removeItem(AUTH_STORE_KEY)
}
